(function (window, document) {
  'use strict';

  class BuybackPortal extends HTMLElement {
    connectedCallback() {
      this._views = {
        login: document.querySelector('buyback-portal-login'),
        list: document.querySelector('buyback-portal-list'),
        detail: document.querySelector('buyback-portal-detail'),
      };
      this._onHashChange = this._route.bind(this);
      window.addEventListener('hashchange', this._onHashChange);
      this._bootstrap();
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this._onHashChange);
    }

    async _bootstrap() {
      try {
        if (window.buybackApi && window.buybackApi.me) {
          var meRes = await window.buybackApi.me();
          window.__buybackMe = meRes || null;
        }
        if (!window.location.hash || window.location.hash === '#') {
          window.location.hash = '#/list';
        } else {
          this._route();
        }
      } catch (err) {
        if (err && err.message === 'UNAUTHENTICATED') {
          // apiClient already redirected to #/login
          this._route();
          return;
        }
        window.location.hash = '#/login';
      }
    }

    _route() {
      var hash = window.location.hash || '';
      var view = 'login';
      if (hash.indexOf('#/list') === 0) view = 'list';
      else if (hash.indexOf('#/detail/') === 0) view = 'detail';
      else if (hash.indexOf('#/login') === 0) view = 'login';

      var prevView = this._currentView || null;
      var keys = Object.keys(this._views);
      for (var i = 0; i < keys.length; i++) {
        var k = keys[i];
        var el = this._views[k];
        if (!el) continue;
        if (k === view) el.classList.add('is-active');
        else el.classList.remove('is-active');
      }
      this._currentView = view;

      // Reset scroll au changement de vue (sinon la position est conservée entre
      // list/detail → flash visuel "bas de page remonte" en entrée detail, et
      // atterrissage en bas de liste au retour depuis un detail long).
      if (prevView !== view) {
        try {
          window.scrollTo(0, 0);
        } catch (e) {
          /* ignore */
        }
      }

      if (view === 'detail' && this._views.detail) {
        this._views.detail.dispatchEvent(new CustomEvent('bp:hash-change', { detail: { hash: hash } }));
      }
    }
  }

  if (!customElements.get('buyback-portal')) {
    customElements.define('buyback-portal', BuybackPortal);
  }
})(window, document);
